import {
  FaBootstrap,
  FaCss3Alt,
  FaGitAlt,
  FaGithub,
  FaHtml5,
  FaJava,
  FaJs,
  FaNodeJs,
  FaReact,
  FaSass,
} from "react-icons/fa"
import { SiFirebase, SiRedux } from "react-icons/si"

export const SKILLS = [
  {
    id: 1,
    name: "HTML5",
    icon: FaHtml5,
  },
  {
    id: 2,
    name: "CSS3",
    icon: FaCss3Alt,
  },
  {
    id: 3,
    name: "SASS",
    icon: FaSass,
  },
  {
    id: 4,
    name: "Bootstrap",
    icon: FaBootstrap,
  },
  {
    id: 5,
    name: "JavaScript",
    icon: FaJs,
  },
  {
    id: 6,
    name: "React & Native",
    icon: FaReact,
  },
  {
    id: 7,
    name: "Redux",
    icon: SiRedux,
  },
  {
    id: 8,
    name: "NodeJS",
    icon: FaNodeJs,
  },
  {
    id: 9,
    name: "Firebase",
    icon: SiFirebase,
  },
  {
    id: 10,
    name: "Git",
    icon: FaGitAlt,
  },
  {
    id: 11,
    name: "GitHub",
    icon: FaGithub,
  },

  {
    id: 12,
    name: "Java",
    icon: FaJava,
  },
]
